export const DOCUMENT_VISIVILITIES = {
  private: '自分のみ',
  all_admins: '管理者全体',
} as const
